import { all } from 'typed-redux-saga'
import {
	agreementSagas,
	landingsSaga,
	merchantStatusSaga,
	fakeResponsesSagas,
	templateSaga,
	productOrderStatusesSaga,
	serviceNotificationsSaga,
	tagSaga,
} from 'Pages/admin'

export function* adminSagas() {
	yield* all([
		agreementSagas(),
		landingsSaga(),
		merchantStatusSaga(),
		fakeResponsesSagas(),
		templateSaga(),
		productOrderStatusesSaga(),
		serviceNotificationsSaga(),
		tagSaga(),
	])
}
